import {Component, ChangeDetectionStrategy} from '@angular/core';
import {ApplicationStatus, PoiDbService} from '../../poi-db/poi-db.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-poi-app-status',
    imports: [
        ReactiveFormsModule,
        FormsModule
    ],
    templateUrl: './poi-app-status.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './poi-app-status.component.scss'
})
export class PoiAppStatusComponent {

  env: string = null;
  application: string = null;

  applicationStatus: ApplicationStatus = null;

  constructor(
    private poiDbService: PoiDbService,
    private notificationService: ToastrService,
  ) {
  }

  refresh() {
    this.poiDbService.getApplicationStatus(this.env, this.application).subscribe({
      next: res => this.applicationStatus = res,
      error: err => {
        console.warn('failed to retrieve data', err);
        this.notificationService.error('failed to retrieve data');
      },
    });
  }

  format(applicationVersion: string) {
    const split = applicationVersion.split('.');
    const last = split[split.length -1];
    return `${last.slice(0, 4)}-${last.slice(4, 6)}-${last.slice(6, 8)} ${last.slice(8, 10)}:${last.slice(10, 12)}`;
  }
}
